var map = {
	"./BadgeTemplates-01.svg": 2648,
	"./BadgeTemplates-02.svg": 2649,
	"./BadgeTemplates-03.svg": 2650,
	"./BadgeTemplates-04.svg": 2651,
	"./BadgeTemplates-05.svg": 2652,
	"./BadgeTemplates-06.svg": 2653,
	"./BadgeTemplates-07.svg": 2654,
	"./BadgeTemplates-08.svg": 2655,
	"./BadgeTemplates-09.svg": 2656,
	"./BadgeTemplates-10.svg": 2657,
	"./BadgeTemplates-11.svg": 2658,
	"./BadgeTemplates-12.svg": 2659,
	"./BadgeTemplates-13.svg": 2660,
	"./BadgeTemplates-14.svg": 2661,
	"./BadgeTemplates-15.svg": 2662,
	"./BadgeTemplates-16.svg": 2663,
	"./BadgeTemplates-17.svg": 2664,
	"./BadgeTemplates-18.svg": 2665,
	"./BadgeTemplates-19.svg": 2666,
	"./BadgeTemplates-20.svg": 2667,
	"./BadgeTemplates-21.svg": 2668,
	"./BadgeTemplates-22.svg": 2669,
	"./BadgeTemplates-23.svg": 2670,
	"./BadgeTemplates-24.svg": 2671,
	"./BadgeTemplates-25.svg": 2672,
	"./BadgeTemplates-26.svg": 2673,
	"./BadgeTemplates-27.svg": 2674,
	"./BadgeTemplates-28.svg": 2675,
	"./BadgeTemplates-29.svg": 2676,
	"./BadgeTemplates-30.svg": 2677,
	"./BadgeTemplates-31.svg": 2678,
	"./BadgeTemplates-32.svg": 2679,
	"./BadgeTemplates-33.svg": 2680,
	"./BadgeTemplates-34.svg": 2681,
	"./BadgeTemplates-35.svg": 2682,
	"./BadgeTemplates-36.svg": 2683,
	"./BadgeTemplates-37.svg": 2684,
	"./BadgeTemplates-38.svg": 2685,
	"./BadgeTemplates-39.svg": 2686,
	"./BadgeTemplates-40.svg": 2687,
	"./BadgeTemplates-41.svg": 2688,
	"./BadgeTemplates-42.svg": 2689,
	"./BadgeTemplates-43.svg": 2690,
	"./BadgeTemplates-44.svg": 2691,
	"./BadgeTemplates-45.svg": 2692,
	"./BadgeTemplates-46.svg": 2693,
	"./BadgeTemplates-47.svg": 2694,
	"./BadgeTemplates-48.svg": 2695,
	"./BadgeTemplates-49.svg": 2696,
	"./BadgeTemplates-50.svg": 2697,
	"./BadgeTemplates-51.svg": 2698,
	"./BadgeTemplates-52.svg": 2699,
	"./BadgeTemplates-53.svg": 2700,
	"./BadgeTemplates-54.svg": 2701,
	"./BadgeTemplates-55.svg": 2702,
	"./BadgeTemplates-56.svg": 2703,
	"./BadgeTemplates-57.svg": 2704,
	"./BadgeTemplates-58.svg": 2705,
	"./BadgeTemplates-59.svg": 2706,
	"./BadgeTemplates-60.svg": 2707,
	"./BadgeTemplates-61.svg": 2708,
	"./BadgeTemplates-62.svg": 2709,
	"./BadgeTemplates-63.svg": 2710,
	"./BadgeTemplates-64.svg": 2711,
	"./BadgeTemplates-65.svg": 2712,
	"./BadgeTemplates-66.svg": 2713,
	"./BadgeTemplates-67.svg": 2714,
	"./BadgeTemplates-68.svg": 2715,
	"./BadgeTemplates-69.svg": 2716,
	"./BadgeTemplates-70.svg": 2717,
	"./BadgeTemplates-71.svg": 2718,
	"./BadgeTemplates-72.svg": 2719,
	"./BadgeTemplates-73.svg": 2720,
	"./BadgeTemplates-74.svg": 2721,
	"./BadgeTemplates-75.svg": 2722,
	"./BadgeTemplates-76.svg": 2723,
	"./BadgeTemplates-77.svg": 2724,
	"./BadgeTemplates-78.svg": 2725,
	"./BadgeTemplates-79.svg": 2726,
	"./BadgeTemplates-80.svg": 2727,
	"./BadgeTemplates-81.svg": 2728,
	"./BadgeTemplates-82.svg": 2729,
	"./BadgeTemplates-83.svg": 2730,
	"./BadgeTemplates-84.svg": 2731,
	"./BadgeTemplates-85.svg": 2732,
	"./BadgeTemplates-86.svg": 2733,
	"./BadgeTemplates-87.svg": 2734,
	"./BadgeTemplates-88.svg": 2735,
	"./BadgeTemplates-89.svg": 2736,
	"./BadgeTemplates-90.svg": 2737,
	"./badge1.svg": 2738,
	"./badge10.svg": 2739,
	"./badge2.svg": 2740,
	"./badge3.svg": 2741,
	"./badge4.svg": 2742,
	"./badge5.svg": 2743,
	"./badge6.svg": 2744,
	"./badge7.svg": 2745,
	"./badge8.svg": 2746,
	"./badge9.svg": 2747
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1405;